import { render, staticRenderFns } from "./VodSection.vue?vue&type=template&id=2ce3ac62&scoped=true&"
import script from "./VodSection.vue?vue&type=script&lang=js&"
export * from "./VodSection.vue?vue&type=script&lang=js&"
import style0 from "./VodSection.vue?vue&type=style&index=0&id=2ce3ac62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3ac62",
  null
  
)

export default component.exports